export class Reports {
    id: number;
    ReportsTypesId: number;
    AgentId: number;
    Params: string;
    Status: string;
    GUID: string;
    UID: string;
    IsNeedSendEmail: boolean;
    Error: string;
    createdAt: Date;
    updatedAt: Date;    
}